// Pages Store
import { clone } from 'lodash'

const page = {
  id: null,
  title: '',
  modules: [],
}

const state = {
  pending: false,
  page: clone(page),
  legal_pages: {},
  modules: [],
}

const getters = {}

const actions = {
  getPage({ commit }, id) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
      .getItem(`pages.${id}`)
      .then(({ data }) => {
        commit('SET_PAGE', data)
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  getLegalPages({ commit }) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
      .getItems('legal_pages')
      .then(({ data }) => {
        commit('SET_LEGAL_PAGES', data)
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  getSearchResultsPage({ commit }, query) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
      .searchItems('pages.search', { page: 1, query })
      .then(({ data }) => {
        commit('SET_PAGE', data)
        commit('SET_MODULES', data)
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  getPreview({ commit }, id) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
      .getItem(`previews.${id}`)
      .then(({ data }) => {
        commit('SET_PAGE', data)
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  clearPage({ commit }) {
    commit('CLEAR_PAGE')
  },
}

const mutations = {
  SET_PENDING: state => {
    state.pending = !state.pending
  },
  CLEAR_PAGE(state) {
    state.page = {}
  },
  SET_PAGE: (state, payload) => {
    state.page = payload
  },
  SET_LEGAL_PAGES: (state, payload) => {
    // prepare data for store
    const tmp_legal_pages = {}
    if (payload.legal_pages) {
      payload.legal_pages.forEach(legal_page => tmp_legal_pages[legal_page.type_string] = {
        page_id: legal_page.page_id,
        title: legal_page.title,
      })
      if (tmp_legal_pages['privacy'] && !tmp_legal_pages['datenschutz']) {
        tmp_legal_pages['datenschutz'] = tmp_legal_pages['privacy']
      }
      state.legal_pages = tmp_legal_pages
    }
  },
  SET_MODULES: (state, payload) => {
    state.modules = payload.modules
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
